import { Spacing } from '@persona-id/design-tokens';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import UnauthenticatedPage from 'dashboard/components/UnauthenticatedPage';
import FormUserEmail from 'dashboard/forms/FormUserEmail';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { Heading } from 'design-system/components/Text';

const BackToLoginLink = styled(Link)`
  width: 100%;
  text-align: center;
  display: inline-block;
  margin-top: ${Spacing[4]};

  &:hover {
    text-decoration: underline;
  }
`;

const SuccessMessage = styled('p')`
  margin-bottom: ${Spacing[4]};
`;

interface DashboardResetViewProps {
  resetSent: boolean;
  submittingResend: boolean;
  createReset: (values: any) => void;
  resendReset: () => void;
}

const DashboardResetView = ({
  resetSent,
  submittingResend,
  createReset,
  resendReset,
}: DashboardResetViewProps) => {
  return (
    <UnauthenticatedPage>
      <Heading size='sm'>Reset your password</Heading>
      <Spacer height={2.5} />
      {resetSent ? (
        <div>
          <SuccessMessage data-test='password-reset__success-message'>
            An email with instructions to reset your password was sent to your account.
          </SuccessMessage>
          <Button
            id='password-reset__submit-button'
            disabled={submittingResend}
            isPending={submittingResend}
            onClick={resendReset}
          >
            Resend instructions
          </Button>
        </div>
      ) : (
        <FormUserEmail onSubmit={createReset} />
      )}
      <BackToLoginLink data-test='password-reset__login-link' to='/dashboard/login'>
        Back to login
      </BackToLoginLink>
    </UnauthenticatedPage>
  );
};

export default DashboardResetView;
